import { setField } from '@cerebral/forms/operators'
import { props, state } from 'cerebral/tags'
import { set, unset } from 'cerebral/operators'
import isValidField from 'modules/Media/factories/isValidField'
import determineBasketError from '../actions/determineBasketError'
import setRelationalSize from '../actions/setRelationalSize'

export default [
  setField(state`${props`path`}.form.${props`name`}`, props`value`),
  isValidField(state`${props`path`}.form.${props`name`}`),
  {
    true: [
      setRelationalSize,
      unset(state`${props`path`}.error`),
      set(state`${props`path`}.done`, true)
    ],
    false: [
      determineBasketError,
      set(state`${props`path`}.done`, false),
      ({ props, state }) => {
        state.set(`${props.path}.error`, {
          key: `bms.orderBasket.errors.${props.error}`,
          params: props.params
        })
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Basket/chains/setSize.js